import { GzInputNumberWithDropdownWebComponent } from './component/GzInputNumberWithDropdownWebComponent';

export { GzInputNumberWithDropdownWebComponent };
